import { api } from '@/services/api'

class UserService {
    async getCurrentUser() {
        try {
            const userData = await api.getRaw('user/current/')
            if (userData) userData.isNewUser = userData?.newUser
            return userData || {}
        } catch (e) {
            console.error(e)
            return {}
        }
    }
}

export const userService = new UserService()
